define('lq/events/actions/cq',[
    'lq/events/actions/eventAction',
    'lq/validatorGateway',
], function (EventAction, validatorGateway) {
    'use strict';

    function CQ(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
    }

    EventAction.extend(CQ, EventAction);

    CQ.typeName = 'CQ';

    CQ.prototype.getBatchType = function () {
        return EventAction.DO_NOT_BATCH;
    };

    CQ.prototype.execute = function (continuation) {
		if (this.eventData.mockMailTo) {
			this.showMail(this.eventData, continuation)
		} 
		else if (this.eventData.viewKey) {
			this.showView(this.eventData, continuation)
		}
		else {
			var eventName = this.mapEventName(this.eventData)
			var eventValue = this.mapArgumentValue(this.eventData)
	
			if (eventValue && !this.eventData.cqGoBack) this.piping.parameters.locals.setValue("ProcessId", eventValue);
			this.piping.eventing.publish(eventName, this.eventSource, eventValue, continuation, this.getEventActionIdentifier());
		}
    };

    CQ.prototype.mapEventName = function (eventData) {
		if (eventData.cqStartProcessId)
			return 'MP Start Process';
		if (eventData.cqStartTodo)
		    return 'MP Start Todo';
		if (eventData.cqCancelTodo)
		    return 'MP Cancel Todo';
		if (eventData.cqCancelAndContinueId)
			return 'MP Cancel Todo And Continue';
		if (eventData.cqFinishTodo)
		    return 'MP Finish Todo';
		if (eventData.cqFinishAndContinueId)
			return 'MP Finish Todo And Continue';
		if (eventData.cqFinishAll)
		    return 'MP Finish All';
		if (eventData.cqCancelAll)
		    return 'MP Cancel All';
		if (eventData.cqGoBack)
		    return 'MP Go To Previous';
        if (eventData.cqLogin)
            return 'MP Login';
		if (eventData.cqLogoff)
		    return 'MP Logoff';
		if (eventData.cqStartMock)
		    return 'MP Start Mock';
    };
    
    CQ.prototype.mapArgumentValue = function (eventData) {
		var self = this;
		if (eventData.cqStartProcessId)
			return eventData.cqStartProcessId;
		if (eventData.cqCancelAndContinueId)
			return eventData.cqCancelAndContinueId;
		if (eventData.cqFinishAndContinueId)
			return eventData.cqFinishAndContinueId;
		if (eventData.cqGoBack && eventData.cqGoBackParameters) {
			var paramObj = {};
			_.each(eventData.cqGoBackParameters, function (param) { 
				paramObj[param] = self.piping.parameters.locals.getValue(param)
			});
			return paramObj;
		}
    };

    CQ.prototype.showMail = function (eventData, continuation) {
		var self = this;
		var messageId = Math.floor(Math.random() * 1E10);
		
		var responseListener = function (message) {
			if (!message.data || message.data.id !== messageId) return;
			if (message.data.type === "POPUP_CLOSED") {
				window.removeEventListener('message', responseListener);
				continuation();
			}
			if (message.data.type === "EMAIL_POPUP_START_PROCESS") {
				window.removeEventListener('message', responseListener);
				if (message.data.cqProcessId) self.piping.parameters.locals.setValue("ProcessId", message.data.cqProcessId);
				self.piping.eventing.publish("MP Start Process", self.eventSource, message.data.cqProcessId, function () { continuation({ break: true }); }, self.getEventActionIdentifier());
			}
		};

		window.addEventListener('message', responseListener);

		validatorGateway.publishEvent({
			type: "SHOW_EMAIL_POPUP",
			id: messageId,
			mail: {
				to: eventData.mockMailTo,
				cc: eventData.mockMailCc,
				bcc: eventData.mockMailBcc,
				subject: eventData.mockMailSubject,
				body: eventData.mockMailBody,
				processOptions: eventData.mockMailProcessOptions
			},
		});
	};

    CQ.prototype.showView = function (eventData, continuation) {
		this.rootDrop.applyView(eventData.viewKey);
		continuation();
	};

    return CQ;
});

